// extracted by mini-css-extract-plugin
module.exports = {"cancel":"AssesmentGrid_cancel__2J7Yz","notification":"AssesmentGrid_notification__2lQy9","head":"AssesmentGrid_head__3yX_8"};